import { createStore } from 'vuex'

export default createStore({
  state: {
      websiteId: 0,
      // 监听这个session来触发更新
      statisticDataSession: 0,
      websiteBasicInfo: {},
      // wxShareConfig: {},
      // 全局更新分享信息，设置一个接收者来进行wx设置。比较粗糙，需要一个更好的方法
      // wxShareInfo: {},
  },
  mutations: {
    updateWebsiteId (state, websiteId) {
      state.websiteId = websiteId;
    },
    // 触发更新 this.$store.commit('needsUpdateStatisticData')
    needsUpdateStatisticData(state) {
      state.statisticDataSession += 1; 
    },
       // 触发更新 this.$store.commit('updateWebsiteBasicInfo', data)
    updateWebsiteBasicInfo(state, info) {
      state.websiteBasicInfo = info;
    },
    // updateWxShareConfig(state, config) {
    //   state.wxShareConfig = config;
    // },
    // updateWxShareInfo(state, shareInfo) {
    //   state.wxShareInfo = shareInfo;
    // }
  },
  actions: {
  },
  modules: {
  }
})
